import { ReduxStore } from 'store/types';

function addNoteIsLoading(state: ReduxStore): boolean {
  return state.intervention.addNote.config.isLoading;
}

export default addNoteIsLoading;
